import _ from 'underscore';
import { VISUAL_TYPES } from '../consts';

const chartTypes = [
  VISUAL_TYPES.COLUMN_CHART,
  VISUAL_TYPES.LINE_CHART,
  VISUAL_TYPES.LINE_WEEKLY_CHART,
  VISUAL_TYPES.LINE_COLUMN_CHART,
];

/**
 * Format visual data chart, e.g category string
 * @param {Object} i18n - Localization component
 * @param {string} visualType - visual type
 * @param {Object} visualData - visual data
 * @return {Object} formatted visual data
 */
export const formatVisualDataChart = (i18n, visualType, visualData) => {
  if (_.contains(chartTypes, visualType)) {
    const category = visualData.category || null;

    // eslint-disable-next-line no-param-reassign
    visualData.title = visualData.localizeCategory ?
      i18n.getString(category) : category;
  }

  return visualData;
};
